/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from '../config'
import Adyen, { getUrl } from '../services/AdyenPOS'
import PayByLink from '../services/PayByLink'
import get from 'lodash/get'

export default {
  adyenGetPos (ctx) {
    return Adyen(getUrl('pos', 'connection'), {
      body: JSON.stringify({
        'merchantAccount': Config.payments.adyen.pos.merchant,
        'store': ctx.rootGetters['userAdmin/getUserStoreId']
      })
    })
      .then((response) => {
        return response.json()
      })
      .then(data => {
        const POIID = data.uniqueTerminalIds[0]
        if (!POIID) {
          // eslint-disable-next-line
          throw { err: { errors: [{ message: 'pos.no-terminals-found' }] } }
        } else {
          return POIID
        }
      })
  },
  payByAdyenPOS (ctx, { orderId, times = 1 }) {
    ctx.commit('setPaymentMessage', 'checkout.live-message.connecting-to-terminal')
    return ctx.dispatch('adyenGetPos')
      .then(POIID => {
        ctx.commit('setPaymentMessage', 'checkout.live-message.terminal-found')
        setTimeout(() => {
          ctx.commit('setPaymentMessage', 'checkout.live-message.await-for-payment')
        }, 1000)
        const SaleID = ctx.rootState.storeConfig.config.code
        let amount = ctx.rootGetters['cart/totalAmount']
        return Adyen(getUrl('pos', 'sync'), {
          body: JSON.stringify(
            {
              'SaleID': SaleID,
              'POIID': POIID,
              'TransactionID': orderId,
              'RequestedAmount': parseFloat(amount)
            })
        })
          .then((response) => {
            return response.json()
          })
          .then(data => {
            ctx.commit('setPaymentMessage', 'checkout.live-message.check-payment-status')
            return new Promise((resolve, reject) => {
              let response = data.SaleToPOIResponse.PaymentResponse.Response
              if (response) {
                if (response.Result === 'Success') {
                  // get PSP reference
                  let paymentResponse = data.SaleToPOIResponse.PaymentResponse
                  let pspReference = get(paymentResponse, 'PaymentResult.PaymentAcquirerData.AcquirerTransactionID.TransactionID', '')
                  let paymentBrand = get(paymentResponse, 'PaymentResult.PaymentInstrumentData.CardData.PaymentBrand', '')
                  if (!pspReference) {
                    let transactionID = get(paymentResponse, 'POIData.POITransactionID.TransactionID', '')
                    if (transactionID) {
                      pspReference = transactionID.split('.')[1]
                    }
                  }
                  resolve({ pspReference, paymentBrand })
                } else if (response.Result === 'Failure' && response.ErrorCondition !== 'Cancel') {
                  // try again
                  // try maximum 5 times
                  times++
                  if (times <= 5) {
                    ctx.commit('setPaymentMessage', global.$i18n.t('checkout.live-message.try-to-process-payment-again-{times}', { times }))
                    setTimeout(() => {
                      return ctx.dispatch('payByAdyenPOS', { orderId, times })
                        .catch((err) => {
                          return reject(err)
                        })
                    }, 4000)
                  } else {
                    // eslint-disable-next-line
                    throw { errors: [{ message: `Payment ${response.ErrorCondition}` }] }
                  }
                } else {
                  // eslint-disable-next-line
                  throw { errors: [{ message: `Payment ${response.ErrorCondition}` }] }
                }
              } else {
                reject(data)
              }
            })
          })
      })
  },
  payByAdyenMail (ctx, { orderId }) {
    let shopperEmail = ctx.rootGetters['checkout/email']
    let amount = Math.trunc(ctx.rootGetters['cart/totalAmount'] * 100)
    return PayByLink(null,
      JSON.stringify({
        'reference': orderId,
        'amount': amount,
        'shopperEmail': shopperEmail,
        'shopperReference': 'test',
        'description': 'TEST',
        'countryCode': 'IT',
        'shopperLocale': 'it-IT'
      })
    )
  }
}
